import { ICONS_NAME } from '@/constants/ui/icons.constants';

export enum InfoBoxPatternKey {
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    RED_WARNING = 'RED_WARNING',
    DANGER = 'DANGER',
    INFO = 'INFO',
    NEUTRAL = 'NEUTRAL'
}

export const InfoBoxPattern = new Map<InfoBoxPatternKey, Record<string, string>>([
    [InfoBoxPatternKey.SUCCESS, { class: 'success', icon: ICONS_NAME.CHECK_CIRCLE_SOLID }],
    [InfoBoxPatternKey.WARNING, { class: 'warning', icon: ICONS_NAME.WARNING_SOLID }],
    [InfoBoxPatternKey.RED_WARNING, { class: 'red-warning', icon: ICONS_NAME.WARNING_SOLID }],
    [InfoBoxPatternKey.DANGER, { class: 'danger', icon: ICONS_NAME.DANGER_SOLID }],
    [InfoBoxPatternKey.INFO, { class: 'info', icon: ICONS_NAME.INFO_CIRCLE_SOLID }],
    [InfoBoxPatternKey.NEUTRAL, { class: 'neutral', icon: ICONS_NAME.QUESTION_MARK_CIRCLE_SOLID }]
]);
